export const SS_CONTACT = {
  phone: '(209) 278-4924',
  email: 'shipstack@icloud.com',
  addrLine1: '1162 Country Club Ln, Suite 1164-102',
  addrLine2: 'Fort Worth, TX 76112',
};
